/**
 * Tipos compartilhados entre os relatórios (Clientes, Contratos, Faturas)
 */

export type ReportType = 'clientes' | 'contratos' | 'faturas' | 'faturamento' | 'dici' | 'conexoes' | 'mensagens';
export type OrderDir = 'asc' | 'desc';

export const REPORT_TAB_PERMISSIONS: Record<ReportType, string> = {
  clientes: 'relatorios.clientes.acessar',
  contratos: 'relatorios.contratos.acessar',
  faturas: 'relatorios.faturas.acessar',
  faturamento: 'relatorios.faturamento.acessar',
  dici: 'relatorios.dici.acessar',
  conexoes: 'relatorios.conexoes.acessar',
  mensagens: 'relatorios.mensagens.acessar',
};

export const RELATORIOS_PAGE_PERMISSIONS = [
  'relatorios.acessar',
  ...Object.values(REPORT_TAB_PERMISSIONS),
];

/** Filtros da aba Clientes */
export interface FiltersClientes {
  search: string;
  dataInicio: string;
  dataFim: string;
  estado: string;
  cidade: string;
  bairro: string;
  statusCliente: string;
  tipoPessoa: string;
  comContratosAtivos: boolean;
  inadimplente: boolean;
}

/** Filtros da aba Contratos */
export interface FiltersContratos {
  search: string;
  dataInicio: string;
  dataFim: string;
  dataBloqueioInicio: string;
  dataBloqueioFim: string;
  dataInstalacaoInicio: string;
  dataInstalacaoFim: string;
  dataCancelamentoInicio: string;
  dataCancelamentoFim: string;
  desbloqueioConfiancaInicio: string;
  desbloqueioConfiancaFim: string;
  estado: string;
  cidade: string;
  bairro: string;
  statusContrato: string;
  vendedor: string;
  plano: string;
  inadimplente: boolean;
}

/** Filtros da aba Faturas e Financeiro */
export interface FiltersFaturas {
  search: string;
  dataInicio: string;
  dataFim: string;
  dataPagamentoInicio: string;
  dataPagamentoFim: string;
  dataCriacaoInicio: string;
  dataCriacaoFim: string;
  estado: string;
  cidade: string;
  bairro: string;
  statusFatura: string;
  tipoFatura: string;
  quickFilter?: string;
}

/** Filtros da aba Faturamento */
export interface FiltersFaturamento {
  dataInicio: string;
  dataFim: string;
  dimensao: 'bairro' | 'plano' | 'dia_vencimento' | 'periodo';
  granularidade: 'diario' | 'mensal' | 'anual';
  bairro: string;
  planoId: string;
  diaVencimento: string;
  quickFilter?: string;
}

/** @deprecated Use FiltersClientes, FiltersContratos ou FiltersFaturas */
export type FiltersState = FiltersClientes & FiltersContratos & FiltersFaturas;

export const filtersClientesDefault: FiltersClientes = {
  search: '',
  dataInicio: '',
  dataFim: '',
  estado: '',
  cidade: '',
  bairro: '',
  statusCliente: '',
  tipoPessoa: '',
  comContratosAtivos: false,
  inadimplente: false,
};

export const filtersContratosDefault: FiltersContratos = {
  search: '',
  dataInicio: '',
  dataFim: '',
  dataBloqueioInicio: '',
  dataBloqueioFim: '',
  dataInstalacaoInicio: '',
  dataInstalacaoFim: '',
  dataCancelamentoInicio: '',
  dataCancelamentoFim: '',
  desbloqueioConfiancaInicio: '',
  desbloqueioConfiancaFim: '',
  estado: '',
  cidade: '',
  bairro: '',
  statusContrato: '',
  vendedor: '',
  plano: '',
  inadimplente: false,
};

export const filtersFaturasDefault: FiltersFaturas = {
  search: '',
  dataInicio: '',
  dataFim: '',
  dataPagamentoInicio: '',
  dataPagamentoFim: '',
  dataCriacaoInicio: '',
  dataCriacaoFim: '',
  estado: '',
  cidade: '',
  bairro: '',
  statusFatura: '',
  tipoFatura: '',
  quickFilter: 'current-month',
};

export const filtersFaturamentoDefault: FiltersFaturamento = {
  dataInicio: '',
  dataFim: '',
  dimensao: 'periodo',
  granularidade: 'mensal',
  bairro: '',
  planoId: '',
  diaVencimento: '',
  quickFilter: 'current-month',
};

/** @deprecated Use filtersClientesDefault, filtersContratosDefault ou filtersFaturasDefault */
export const filtersDefault = {
  ...filtersClientesDefault,
  ...filtersContratosDefault,
  ...filtersFaturasDefault,
};

export const estadosBR = [
  'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA',
  'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
];
